import { GlobalLoadingService } from '@core/services/globalLoading.service';
import { Component, inject } from '@angular/core';

@Component({
  selector: 'global-common-progressspinner',
  standalone: false,
  templateUrl: './global-progress-spinner.component.html',
  styleUrls: ['./global-progress-spinner.component.css'],
})
export class GlobalProgressSpinnerComponent {
  public loadingService = inject(GlobalLoadingService);
}
